import { Pagination } from 'react-bootstrap';
import './MercurXTablePagination.scss';

function MercurXTablePagination({
  currentPage,
  totalPages,
  visiblePages,
  isFirstPage,
  isLastPage,
  onFirstPage,
  onPrevPage,
  onPageChange,
  onNextPage,
  onLastPage,
}) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mercurx-table-pagination-wrap">
      <div className="mercurx-table-pagination-summary">
        Page {currentPage} of {totalPages}
      </div>
      <Pagination className="mercurx-table-pagination">
        <Pagination.First disabled={isFirstPage} onClick={onFirstPage} />
        <Pagination.Prev disabled={isFirstPage} onClick={onPrevPage} />
        {visiblePages.map((pageNumber) => (
          <Pagination.Item
            key={pageNumber}
            active={pageNumber === currentPage}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </Pagination.Item>
        ))}
        <Pagination.Next disabled={isLastPage} onClick={onNextPage} />
        <Pagination.Last disabled={isLastPage} onClick={onLastPage} />
      </Pagination>
    </div>
  );
}

export default MercurXTablePagination;
